import { Title } from "../../../../../library/title";
import {
  DetailsRow,
  LeftDetailsCol,
  ThumbnailWrapper,
  ThumbnailCol,
  Thumbnail,
  InformationCol,
  RightDetailsCol,
  TitleBadge,
  DetailsWrapper,
  BadgeWrapper,
} from "./styled";
import { Text } from "../../../../../library/text";
import thumbnail from "../../../../../assets/img/thumbnail.svg";
import useUser from "../../../../../hooks/useUser";
import { useSelector } from "react-redux";
import { IState } from "../../../../../types";
import Skeleton from "react-loading-skeleton";
import { formatFirebaseTime } from "../../../../../utils/date-format";

const UpperArea = () => {
  const { loading } = useUser();
  const user = useSelector((state: IState) => state.user);
  const details = useSelector((state: IState) => state.user?.details);

  const renderText = () => {
    if (loading) {
      return (
        <>
          <Skeleton width={200} height={30} />
          <Skeleton width={150} height={20} />
        </>
      );
    }

    return (
      <DetailsWrapper>
        <BadgeWrapper>
          <TitleBadge color="blue">
            {user.workspaces?.length ?? 0} arbeidsmiljø
          </TitleBadge>
        </BadgeWrapper>
        <Title size="md">
          {details?.firstName} {details?.lastName}
        </Title>
        <Text size="small" color="dark">
          Registrert siden {formatFirebaseTime(details?.registerDate)}
        </Text>
      </DetailsWrapper>
    );
  };

  return (
    <DetailsRow>
      <LeftDetailsCol>
        <ThumbnailCol>
          <ThumbnailWrapper>
            <Thumbnail src={thumbnail} />
          </ThumbnailWrapper>
        </ThumbnailCol>
        <InformationCol>{renderText()}</InformationCol>
      </LeftDetailsCol>
      <RightDetailsCol></RightDetailsCol>
    </DetailsRow>
  );
};

export default UpperArea;
